import { Component, inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CommonUtil } from '../../../common/util/common-util';
import { BaseComponent } from '../../../common/components/base.component';
import { LanguageStateService } from '../../../common/services/language-state.service';


@Component({
    selector: 'app-ach-billing',
    templateUrl: './ach-billing.component.html',
    styleUrl: './ach-billing.component.scss',
    standalone: false
})
export class AchBillingComponent extends BaseComponent implements OnInit {

  accountTypeOptions: any[] = ['Checking', 'Savings']
  languageService: LanguageStateService = inject(LanguageStateService)

  #fb: FormBuilder = inject(FormBuilder)

  achForm: FormGroup

  initFormGroups() {
    this.achForm = this.#fb.group({
      accountType: ['Checking', [Validators.required]],
      acctHolderName: ['', [Validators.required, Validators.pattern(/^[a-zA-Z\s'-]+$/)]],
      routingNumber: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(9), Validators.maxLength(9)]],
      acctNumber: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(4), Validators.maxLength(17)]],
      confirmAcctNumber: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(4), Validators.maxLength(17)]],
    }, { validators: [this.sameAcctNumberValidator()] })
  }

  ngOnInit(): void {
    this.initFormGroups()
  }

  sameAcctNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control?.get('confirmAcctNumber')?.value && control?.get('acctNumber')?.value !== control?.get('confirmAcctNumber')?.value) {
        return { sameAcctNumber: true };
      }
      return null;
    };
  }
  onlyAlphabets(event: KeyboardEvent): boolean {
    return CommonUtil.onlyAlphabets(event)
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    return CommonUtil.onlyNumbers(event)
  }

}

// @NgModule({
//   declarations: [
//     AchBillingComponent
//   ],
//   imports: [
//     AppBaseModule,
//     SaraPlusFormModule,
//     AppLayoutModule
//   ],
//   exports: [
//     AchBillingComponent
//   ],
//   providers: [
//     { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
//   ]
// })
// export class AchBillingModule {

// }